import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { Link } from "react-router-dom";
import Select from 'react-select';
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";

import { Modal } from "react-bootstrap";
import Loader from "../../../Components/Global/Loader";

import DeleteModal from "../../../Components/Global/modal/DeleteModal";
import TaxModal from "../../../Components/Global/modal/TaxModal";
import TablesList from "../../../Components/Global/TablesList";
import { useAuth } from "../../../Context/AuthContext";
import Paginations from "../../../hooks/Paginations";
import useAuthentication from "../../../hooks/useAuthentication";
import useAxiosFetch from "../../../hooks/useAxiosFetch";
import useSearchListPagination from "../../../hooks/useSearchListPagination";
import useStateProvince from "../../../hooks/useStateProvince";
const options = [
    { value: 'pst', label: 'Pst' },
    { value: 'qst', label: 'Qst' },
    { value: 'hst', label: 'Hst' },
    { value: 'bts', label: 'Bts' },

]

function AllTaxsAccountantPr({ allowedRoles }) {
    const { allowLoading } = useAuthentication(allowedRoles)
    // api api from global hook 

  const { axiosFetch} = useAxiosFetch();


    const [errorMessage, setErrorMessage] = useState({})
    const [show, setShow] = useState(false);
    const [deleteModal, setdeleteModal] = useState({});
    const [footerModal, setfooterModal] = useState("");
    const handleClose = () => setShow(false);
    const [otherExpenses, setotherExpenses] = useState([]);
    const handleShow = () => setShow(true);
    const {
        setisKeyPress,
        Count,
        setsearchKey,
        searchKey,
        setRecord,
        record,
        setPages,
        pages,
        totallength,
        paginationLoading,
        handleNextbtn,
        handlePrevbtn,
        PageShowFunc,
        SearchListApi,
        allData,
        PagesFunc,
        responseData,
    } = useSearchListPagination();


    const [showModals, setShowModals] = useState({
        addModal: false,
        ediModal: false,
        deleteModal: false,
        modalData: {}
    })




    const validation = () => {

        const errors = {};
        if (Object.keys(deleteModal).length === 0) {
            if (!workerData.country) {
                errors.country = "Please Enter a country";
            }
            if (!workerData.province) {
                errors.province = "Please Enter a province";
            }
        }
       

        if (!gst && !qst && !hst && !pst) {

            errors.global = "Please Enter a tax value.";
            setfooterModal("Please Enter at least one tax")
        }
        return errors
    }






    const [workerData, setWorkerData] = useState({

        province: "",
        country: "",
        taxtype: "",
        taxSecond: false,
        taxSecondVal: "",
        gst: "",
        pst: "",
        hst: "",
        qst: "",
        bts: "",

    });
    const {

        province,
        country,
        taxSecond,
        taxSecondVal,
        taxtype,
        gst,
        pst,
        hst,
        qst,
        bts,

    } = workerData;
    const { designation } = useAuth();



    useEffect(() => {

        if (searchKey) {
            SearchListApi(`tax`);
        } else {
            SearchListApi(`tax`);
        }


    }, [searchKey, record, pages]);















    const handleData = (e) => {
        const { value, type } = e.target;
        
  
        setfooterModal("")
        setWorkerData({ ...workerData, [e.target.name]: value });



    };


    const provinceGst = ["666", "667", "669", "671", "672"];
    const provincePst = ["663", "666", "667", "668", "669", "670", "671", "672", "673", "675"];
    const provinceHst = ["663", "664", "665", "668", "670", "673", "674", "675"];
    const provinceQst = ["663", "664", "665", "666", "667", "668", "669", "670", "671", "672", "674", "675"];





    const [countryList, stateList, getProvinceFunc] = useStateProvince();
    useEffect(() => {
        if (country) {

            getProvinceFunc(country)
        }
    }, [country])

    const taxInfosend = async () => {

        const Valid = validation();

        setErrorMessage(Valid);

        if (Object.keys(Valid).length == 0) {
            // setLoadingPagination(true)
            const sendDb = {
                province,
                country,
                tax: {
                    gst,
                    pst,
                    hst,
                    qst,
                    bts,
                }

            }

            try {
                if (Object.keys(deleteModal).length === 0) {
                    if (workerData.createdAt) {


                        axios.post(`/tax/update/${workerData.id}`, sendDb)
                            .then(res => {
                                if (res?.status == 200) {
                                    SearchListApi(`tax`)
                                    handleClose()
                                }
                                // setLoadingPagination(false)

                            }).catch(err => {
                                setfooterModal(err.response.data.msg)
                            })
                    } else {

                        if (Object.keys(workerData).length !== 0) {


                            // return

                            axios.post(`/tax/create`, sendDb)
                                .then(res => {
                                    if (res?.status == 200) {
                                        SearchListApi(`tax`)
                                        handleClose()
                                    } else {

                                        setfooterModal(res?.data?.errMsg)
                                    }
                                    // setLoadingPagination(false)

                                }).catch(err => {
                                    setfooterModal(err.response.data.msg)
                                })
                        }


                    }

                } else {
                    await axios.delete(`/tax/delete/${deleteModal?.id}`)
                        .then(res => {
                            if (res?.status == 200) {
                                SearchListApi(`tax`)
                                handleClose()
                            }
                            // setLoadingPagination(false)

                        }).catch(err => {

                        })


                }

            } catch (error) {
                // setLoadingPagination(false)
            }





        }





    }



    const tableHeaderFieldsName = [
        "Sl No.", "Country", "Province", "Gst", "Qst", "Pst", "Hst", "Action"
    ]
    const tableValueData = {
        value: [
            "country_name", "province_name", "gst", "qst", "pst", "hst"
        ], design: {}
    }

    const [tableBodyValue, settableBodyValue] = useState([])


    useEffect(() => {

        settableBodyValue(allData?.map(data => ({ ...data, ...data.tax })))

    }, [allData])

    const editTaxData = (tax) => {
        setotherExpenses([]); 
        setWorkerData({});
        setWorkerData({ ...tax, ...tax.tax });
        setotherExpenses(Object.keys(tax?.tax).filter(ta => ta?.toLowerCase() !== "gst")?.map(tag => ({ value: tag?.toLowerCase(), label: tag })))
        setShowModals({
            ...Object.keys(showModals).reduce((reduced, key) => ({ ...reduced, [key]: false }), {}), addModal: true
        })

    }



    const deleteSingleTax = async (tax = {}) => {
    

        setdeleteModal(tax)
        setShowModals({
            ...Object.keys(showModals).reduce((reduced, key) => ({ ...reduced, [key]: false }), {}), deleteModal: true, modalData:{id:tax.id,data: `tax of ${tax?.country_name} of  ${tax?.province_name}`}
        })
    }








    const TaxAdd = async () => {

        const Valid = validation();

        setErrorMessage(Valid);

        if (Object.keys(Valid).length == 0) {
const url= workerData.createdAt ? `/tax/update/${workerData.id}` : `/tax/create`
            const sendDb = {
                province,
                country,
                tax: {
                    gst,
                    pst,
                    hst,
                    qst,
                    bts,
                }
    
            }
    
            try {
                const response = await axios.post(url, sendDb);
                if (response?.status == 200) {
                    SearchListApi(`tax`)
                    closeAllModals()
                }
            } catch (error) {
    
            }

        }


       
    }
    const deleteTax = async () => {


        try {
            const response = await axios.delete(`/tax/delete/${showModals?.modalData?.id}`)
            if (response?.status == 200) {
                SearchListApi(`tax`)
                closeAllModals()
            }
        } catch (error) {

        }
    }


    const closeAllModals = () => {
        setShowModals({
            ...Object.keys(showModals).reduce((reduced, key) => ({ ...reduced, [key]: false }), {})
        })
    }
    return (
        <>
            <DashboardLayouts>
                {(paginationLoading || allowLoading) && <Loader />}

                <div className="breadcrumb row justify-content-between align-items-center">
                    <div className="d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
                        <Link
                            to={
                                designation === "Owner" || designation === "Partner"
                                    ? "/dashboard"
                                    : `/${designation}dashboard`.toLowerCase()
                            }
                            className="d-flex align-items-center"
                        >
                            <BsArrowLeft className="me-2 m-0 back-arrow" color="black" />
                            <i className="icon-dashboard"></i>
                            <h3 className="mb-0 fw-normal">Dashboard</h3>
                        </Link>
                    </div>

                    <div className="col-auto btn-responsive">
                   {  designation=="Admin" &&   <button className="btn btn-outline-primary"

                          

                            onClick={() => setShowModals({
                                ...Object.keys(showModals).reduce((reduced, key) => ({ ...reduced, [key]: false }), {}), addModal: true
                            })}

                        >
                            Add Tax
                        </button> }
                    </div>
                </div>
                <>
                    <TablesList
                        tableNameData={tableHeaderFieldsName}

                        designation={designation} tableValueData={tableValueData} datasShow={tableBodyValue}
                        setPages={setPages} pages={pages} record={record} setRecord={setRecord} setsearchKey={setsearchKey} setisKeyPress={setisKeyPress} searchKey={searchKey} SearchListApi={SearchListApi}
                        showTitle={true}

                        title={'Tax'} isSearchField={true} isDeleteIconShow={designation=="Admin"} isEditIconShow={designation=="Admin"} onClickDeleteFunc={deleteSingleTax} onClickEditFunc={editTaxData} />
                </>




                {Count > 5 && totallength.length > 1 &&
                    <Paginations onPageChange={PagesFunc} currentPage={pages} totalPages={totallength.length} />
                }







                <Modal
                    size={"md"}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={show}
                    onHide={handleClose}
                    className="my__modal"
                >
                    <Modal.Header>
                        <Modal.Title
                            id="contained-modal-title-vcenter"
                            className="w-100"
                        >
                            <div className="modal-top">
                                <div className="d-flex justify-content-between align-items-center justify-content-center">
                                    {Object.keys(deleteModal).length === 0 ? <h3 className="heading-text">{workerData.createdAt ? "Edit Tax " : "Add Tax "} </h3>
                                        : <h3 className="heading-text ">Remove Tax </h3>}
                                </div>

                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body >

                        {Object.keys(deleteModal).length === 0

                            ? <>
                                <div className="row">
                                    <div className="col-xl-6 col-md-6 mb-2">
                                        <div className="form-group">
                                            <label htmlFor="" className="form-lbl">
                                                Country<span className="must-field">*</span>
                                            </label>
                                            <select
                                                value={country}
                                                name="country"
                                                onChange={(e) => handleData(e)}
                                                className={`form-control`}
                                                placeholder={`Country`}
                                            >
                                                <option value="">Choose Country</option>
                                                {countryList?.map((items, i) => {
                                                    return (
                                                        <option key={i} value={items.id}>
                                                            {items.country_name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                            {errorMessage?.country ? (
                                                <div
                                                    className="error error-message"
                                                    style={{ color: "red" }}
                                                >
                                                    {errorMessage?.country}
                                                </div>
                                            ) : (
                                                ""
                                            )}

                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-md-6 mb-2">
                                        <div className="form-group">

                                            <label htmlFor="" className="form-lbl">
                                                Province<span className="must-field">*</span>
                                            </label>
                                            <select
                                                value={province}
                                                name="province"
                                                onChange={(e) => handleData(e)}
                                                className={`form-control`}
                                                placeholder={`Province`}
                                            >
                                                {!workerData?.createdAt && <option value="">Please choose a provice</option>}
                                                {stateList?.map((items) => {
                                                    return (
                                                        <option value={items.id} key={items.id}>
                                                            {items.province_name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                            {errorMessage?.province ? (
                                                <div
                                                    className="error error-message"
                                                    style={{ color: "red" }}
                                                >
                                                    {errorMessage?.province}
                                                </div>
                                            ) : (
                                                ""
                                            )}

                                        </div>
                                    </div>
                                    <div className="row m-0 p-0 mb-3 ">
                                        <div className="col-md-12 col-xl-9 mb-2 ">
                                            <div className="form-group">
                                                <label htmlFor="" className="form-lbl">
                                                    Other Taxes
                                                </label>



                                                <Select
                                                    value={otherExpenses}
                                                    isMulti
                                                    name="colors"
                                                    options={options}
                                                    onChange={(item) => {

                                                        setotherExpenses(item)
                                                    }}
                                                    // className="py-3"
                                                    placeholder="choose other taxes"
                                                    classNamePrefix="select Expenses tax-class"

                                                />



                                            </div>
                                        </div>


                                        <div className="row">
                                            <div className="col-xl-3 col-md-3 ">
                                                <div className="form-group">
                                                    <label htmlFor="" className="form-lbl">
                                                        Gst (%)
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={gst}
                                                        // readOnly={readOnlyFields?.includes("gst")}

                                                        name="gst"
                                                        onChange={(e) => handleData(e)}
                                                        className={`form-control `}
                                                        placeholder="Gst "
                                                    />
                                                    {errorMessage?.gst ? (
                                                        <div
                                                            className="error error-message"
                                                            style={{ color: "red" }}
                                                        >
                                                            {errorMessage?.gst}
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>

                                            </div>
                                            {
                                                otherExpenses?.map(oei =>
                                                    <>




                                                        <div className="col-xl-3 col-md-3 " key={oei.value}>
                                                            <div className="form-group">
                                                                <label htmlFor="" className="form-lbl">
                                                                    {oei.label} (%)
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    value={workerData?.[oei.label.toLowerCase()]}
                                                                    // readOnly={readOnlyFields?.includes("bts")}
                                                                    name={oei.label.toLowerCase()}

                                                                    onChange={(e) => handleData(e)}
                                                                    className={`form-control `}
                                                                    placeholder={oei.value}
                                                                />
                                                                {errorMessage?.bts ? (
                                                                    <div
                                                                        className="error error-message"
                                                                        style={{ color: "red" }}
                                                                    >
                                                                        {errorMessage?.bts}
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </div>

                                                        </div>
                                                    </>

                                                )
                                            }
                                        </div>


                                    </div>
                                </div>

                            </>

                            : <><p>Are you sure to delete {`${deleteModal?.province_name} of country ${deleteModal?.country_name}`
                            } ?
                            </p></>
                        }


                    </Modal.Body>
                    <Modal.Footer>
                        <div className="">
                            <div className="">
                                <p className="text-danger">  {footerModal && footerModal}</p>
                            </div>
                            <div className="d-flex">
                                <button
                                    className="px-3 me-2 py-2 border fw-bold d-flex align-items-center justify-content-center text-4 from_input rounded-2"
                                    onClick={() => {
                                        setWorkerData({})
                                        setdeleteModal({})

                                        handleClose()
                                        setfooterModal("")
                                        // setLoadingPagination(false)
                                    }
                                    }

                                >
                                    Cancel
                                </button>
                                <button
                                    className="px-3 py-2 border fw-bold d-flex align-items-center justify-content-center text-4 from_input rounded-2"
                                    onClick={(e) => {
                                        taxInfosend(e)

                                    }}
                                >
                                    Confirm
                                </button>
                            </div>
                        </div>

                    </Modal.Footer>

                </Modal>

                <DeleteModal show={showModals.deleteModal} handleClose={closeAllModals} modalData={showModals?.modalData?.data} handleSubmit={deleteTax} />
                <TaxModal handleSubmit={TaxAdd} show={showModals.addModal} handleClose={closeAllModals} handleData={handleData} country={country} countryList={countryList} errorMessage={errorMessage} province={province} gst={gst} setotherExpenses={setotherExpenses} options={options} otherExpenses={otherExpenses} workerData={workerData} stateList={stateList} />
            </DashboardLayouts>
        </>
    );
}

export default AllTaxsAccountantPr;
